var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHappy = function SvgHappy(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32780_38099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#E2E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5001C35 27.1688 27.1632 35.0001 17.5 35.0001C11.9984 35.0001 7.08746 32.4626 3.8773 28.4868C6.87965 30.9149 10.7023 32.3642 14.864 32.3642C24.5273 32.3642 32.364 24.5329 32.364 14.8642C32.364 10.7024 30.9148 6.87979 28.4867 3.87744C32.457 7.0876 35 11.9985 35 17.5001Z",
    fill: "#CBD6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4843 22.0989C28.1936 27.5239 23.3264 31.5707 17.4968 31.5707C11.6671 31.5707 6.79989 27.5239 5.50926 22.0879C5.41082 21.6723 5.79364 21.3114 6.19832 21.4317C13.7889 23.6957 21.3249 23.7395 28.7952 21.4426C29.2108 21.3114 29.5827 21.6832 29.4843 22.0989Z",
    fill: "#CBD6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7923 26.9829C12.3123 26.9829 9.12071 25.665 9.74196 28.78C9.74524 28.7964 9.75181 28.8117 9.75509 28.8281C11.8693 30.542 14.5599 31.5701 17.4967 31.5701C20.4334 31.5701 23.124 30.5409 25.2382 28.8292C25.2415 28.8117 25.2481 28.7964 25.2513 28.78C25.8726 25.665 21.2734 26.9829 16.7923 26.9829Z",
    fill: "#E24B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37309 21.478C7.03481 23.8515 11.7489 25.6824 17.4747 25.6824C23.1797 25.6824 27.8784 23.8646 28.5675 21.5032C21.2295 23.7126 13.8281 23.6677 6.37309 21.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.606 4.98489C10.606 4.98489 7.05024 4.48504 3.31728 8.80645C3.31728 8.80645 5.73118 1.06489 10.606 4.98489Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3938 4.98489C24.3938 4.98489 27.9496 4.48504 31.6825 8.80645C31.6825 8.80645 29.2686 1.06489 24.3938 4.98489Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2801 13.5342C14.2801 15.7016 12.949 17.4657 11.2985 17.4657C9.64914 17.4657 8.31695 15.7016 8.31695 13.5342C8.31695 11.3667 9.64804 9.61475 11.2985 9.61475C12.9479 9.61475 14.2801 11.3667 14.2801 13.5342Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0397 12.4342C12.7969 12.5892 12.3922 12.4178 12.1614 12.0287C11.9306 11.6506 11.9613 11.2252 12.215 11.0713C12.4578 10.9153 12.8505 11.0988 13.0703 11.4758C13.3131 11.8539 13.2945 12.2793 13.0397 12.4342Z",
    fill: "#5A5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6832 13.5342C26.6832 15.7016 25.3521 17.4657 23.7016 17.4657C22.0522 17.4657 20.72 15.7016 20.72 13.5342C20.72 11.3667 22.0511 9.61475 23.7016 9.61475C25.351 9.61475 26.6832 11.3667 26.6832 13.5342Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4439 12.4342C25.2011 12.5892 24.7964 12.4178 24.5656 12.0287C24.3348 11.6506 24.3644 11.2252 24.6192 11.0713C24.862 10.9153 25.2547 11.0988 25.4745 11.4758C25.7162 11.8539 25.6976 12.2793 25.4439 12.4342Z",
    fill: "#5A5F63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32780_38099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHappy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/happy.1a41f0ad.svg";
export { ForwardRef as ReactComponent };